<template>
  <div class="color-sample n2-west2">
    <section class="flex center grow adjust-top">
      <div class="box grow" />
      <div class="box adjust-padding">
        <p class="small-text">
          俗名
        </p>
      </div>
      <div class="box adjust-padding">
        <p class="small-text">
          源頼朝
        </p>
      </div>
      <div class="box adjust-padding">
        <p class="small-text">
          享年
        </p>
      </div>
      <div class="box adjust-padding">
        <p class="small-text">
          八十八歳
        </p>
      </div>
      <div class="box grow" />
    </section>
    <section class="flex center grow adjust-top">
      <div class="box">
        <p class="small-text">
          平成三年 十二月三十 一日 没
        </p>
      </div>
      <div class="box grow" />
    </section>
    <section />
    <section class="flex center grow adjust-top">
      <div class="box grow" />
      <div class="box adjust-padding">
        <p class="small-text">
          俗名
        </p>
      </div>
      <div class="box adjust-padding">
        <p class="small-text">
          源頼朝
        </p>
      </div>
      <div class="box adjust-padding">
        <p class="small-text">
          享年
        </p>
      </div>
      <div class="box adjust-padding">
        <p class="small-text">
          八十八歳
        </p>
      </div>
      <div class="box grow" />
    </section>
    <section class="flex center grow adjust-top">
      <div class="box">
        <p class="small-text">
          平成三年 十二月三十 一日 没
        </p>
      </div>
      <div class="box grow" />
    </section>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-back.scss";
</style>
